import { formatCurrency } from '../../utils/reuse';
import { useSelector } from 'react-redux';

const BundlePopupHeader = ({labels, simtype, description, redeemPage, price, prices, priceCurrency}) => {
  const { selectedCurrency } = useSelector(state => state.currency);
  return (
    <>
      <div className="header-title">
        <div className='flex justify-content-between align-items-center details-header'>
          <h4>{labels?.LBLN0016}</h4>
          {redeemPage ? null:  <p className="price">{formatCurrency(selectedCurrency || priceCurrency, prices?.[selectedCurrency] || price)}</p>}
        </div>
        <p className="desc">{simtype}, {description?.split("(")[0]}</p>
      </div>
    </>
  )
}

export default BundlePopupHeader